import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import './Loader.scss';
export const Loader = () => {
    const { promiseInProgress } = usePromiseTracker();
    return (React.createElement(React.Fragment, null, promiseInProgress ? (React.createElement("div", { className: "loader show" },
        React.createElement("span", { className: "loader__image" }))) : ''));
};
